import React from 'react'

const Socila = () => {
  return (
    <div className="home-social">
        
         <a href="https://www.instagram.com/su40860?igsh=ZzZtb2dweGpkMHcz" target='blank' className="home-social-icon" >
        <i className="uil uil-instagram"></i>
        </a>

        {/* <a href="https://dribbble.com/HNIN123" target='blank' className="home-social-icon" >
        <i className="uil uil-dribble"></i>
        </a> */}
        <a
        href="https://www.linkedin.com/in/hnin-su-wai-a7629a268/"
        target='blank'
        className="home-social-icon"
      >
        <i className="uil uil-linkedin-alt"></i>
      </a>
        
        <a href="https://github.com/HninSuWai12" target='blank' className="home-social-icon" >
        <i className="uil uil-github-alt"></i>
   
        </a>
    </div>
  )
}

export default Socila
